<section class="other-insurance">
    <div class="container">
        <div class="section-header">
            <div class="other-heading">
                <h2 class="section-title">Otros seguros onLygal para ti</h2>
                <!-- <p class="other-sub">{{ subtitulo }}</p> -->
            </div>
            <a class="section-link" (click)="irA('/hire')">Ver todos los seguros</a>
        </div>

        <div class="other-list">
            <div class="other-row" *ngFor="let seguro of items; let i = index">
                <div class="other-icon" aria-hidden="true">
                    <img class="other-icon-img" [src]="iconForInsurance(seguro, i)" alt="">
                </div>
                <div class="other-body">
                    <div class="other-title-row">
                        <h3 class="other-title">{{ seguro.title }}</h3>
                        <span *ngIf="seguro.nuevo" class="other-tag-new">Nuevo</span>
                    </div>
                    <p class="other-desc">
                        <span>{{ seguro.description }}</span>
                    </p>
                </div>
                <button class="other-btn" (click)="abrirEnlace(seguro.link)" [disabled]="!seguro.link">Descubre</button>
            </div>
        </div>

        <p class="other-footer" *ngIf="footer">{{ footer }}</p>
    </div>
</section>
